export default __webpack_public_path__ + "static/media/ud_all_request.46e76cb1.svg";